import { useRef, useState, useEffect } from "react";
import "./Es3Hero.css";

function Es3Hero() {
  const innerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = innerRef.current;
    if (!el) return;
    let firstFire = true;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (firstFire) {
          firstFire = false;
          return;
        }
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    obs.observe(el);

    const t = setTimeout(() => setVisible(true), 700);

    return () => { clearTimeout(t); obs.disconnect(); };
  }, []);

  const fadeUp = (delay) => ({
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0)" : "translateY(28px)",
    transition: `opacity 0.9s ease ${delay}ms, transform 1s cubic-bezier(.16,.84,.24,1) ${delay}ms`,
  });

  return (
    <header className="es3-hero" id="es3-top">
      <div className="es3-hero-bg">
        <img src="/image/es3/hero-user.jpg" alt="An acoustic night inside Exyst Space" />
      </div>
      <div className="es3-hero-inner" ref={innerRef}>
        <div className="es3-hand es3-hero-hand" style={fadeUp(0)}>your story, your canvas, your stage</div>
        <h1 className="es3-hero-h1" style={fadeUp(140)}>
          The walls are empty.<br /><em>On purpose.</em>
        </h1>
        <p className="es3-hero-sub" style={fadeUp(280)}>
          A room in Lahore with warm light, open shelves and an open door. We are not filling it. You are.
        </p>
        <div className="es3-hero-btns" style={fadeUp(420)}>
          <a className="es3-btn es3-btn-primary" href="#es3-apply">Fill this space</a>
          <a className="es3-btn es3-btn-ghost" href="#es3-room">Step inside</a>
        </div>
      </div>
      <div className="es3-frame-meta">EX 01 · 35mm · 400H</div>
    </header>
  );
}

export default Es3Hero;
